'use client'

import ReactPaginate from 'react-paginate'
import s from './pagination.module.scss'
import { Chevron } from '@/components/svg/chevron/chevron'
import { useBreakpoint } from '@/hooks/use-breakpoint'

type Props = {
  page: number
  pageCount: number
  onPageChange: (page: number) => void
}

export const Pagination = ({ page, pageCount, onPageChange }: Props) => {
  const breakpoint = useBreakpoint()

  if (pageCount <= 1) return null

  const isMobile = breakpoint === 'mobile' || breakpoint === 'tablet'

  return (
    <ReactPaginate
      breakLabel="..."
      pageCount={pageCount}
      pageRangeDisplayed={isMobile ? 1 : 2}
      marginPagesDisplayed={1}
      forcePage={page - 1}
      onPageChange={({ selected }) => onPageChange(selected + 1)}
      previousLabel={
        <span className={s.nav}>
          <Chevron />
          <span className={s.navText}>PREVIOUS</span>
        </span>
      }
      nextLabel={
        <span className={s.nav}>
          <span className={s.navText}>NEXT</span>
          <Chevron style={{ transform: 'rotate(180deg)' }} />
        </span>
      }
      containerClassName={s.container}
      pageClassName={s.pageItem}
      pageLinkClassName={s.pageLink}
      previousClassName={s.navItem}
      previousLinkClassName={s.navLink}
      nextClassName={s.navItem}
      nextLinkClassName={s.navLink}
      activeClassName={s.active}
      disabledClassName={s.disabled}
      renderOnZeroPageCount={() => null}
    />
  )
}
